import { render, staticRenderFns } from "./TaskListUnderway.vue?vue&type=template&id=30f903a2&"
import script from "./TaskListUnderway.vue?vue&type=script&lang=ts&"
export * from "./TaskListUnderway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports